import './styles/App.css';
import React from 'react';
import {BrowserRouter, Routes, Route} from "react-router-dom";
import FileUploadPage from './Pages/FileUploadPage';
import HomePage from './Pages/HomePage'
import Presentations from './Pages/Presentations';
import Interface from './Pages/Interface'
import PresentationDetail from './componenets/PresentationDetail';
import Landing from './Pages/Landing'



import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();



  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  if (auth.error) {
    return <div>Encountering error... {auth.error.message}</div>;
  }

  if (auth.isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes> 
          <Route path = '/' element = {<HomePage/>}/>
          <Route path = '/interface' element = {<Interface/>}/>
          <Route path = '/upload' element = {<FileUploadPage/>}/>
          <Route path = '/presentations' element = {<Presentations/>}/>
          <Route path="/presentations/:id" element={<PresentationDetail/>} />
          <Route path = "/landing" element = {<Landing/>} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <Landing/>
  );
}
  
export default App;
  




